<template>
  <div class="iq-sidebar  sidebar-default ">
    <div class="iq-sidebar-logo d-flex align-items-center justify-content-between">
      <router-link :to="{name: 'product.listproduct'}" class="header-logo">
        <img :src="logo" class="img-fluid rounded-normal" alt="logo">
        <h5 class="logo-title light-logo ml-3">COUPLUS</h5>
      </router-link>
      <div class="iq-menu-bt-sidebar">
        <i class="las la-bars wrapper-menu"></i>
      </div>
    </div>
    <div class="data-scrollbar" data-scroll="1" id="sidebar-scrollbar">
        <nav class="iq-sidebar-menu">
            <ul id="iq-sidebar-toggle" class="iq-menu">
                <!-- 보이는 것이 '내가 연결한 계정' 뿐이라 권한 플래그로 묶지 않는다(라우트도 requiresAuth 없음) -->
                <li :class="checkActive('dashboard.multiAccountDashboard') ? 'active' : ''">
                    <router-link :to="{name: 'dashboard.multiAccountDashboard'}" class="svg-icon">
                        <svg  class="svg-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>
                        </svg>
                        <span class="ml-3">대시보드</span>
                    </router-link>
                </li>
                <!-- <li :class="checkActive('layout.dashboard1') ? 'active' : ''" v-if="showdashboard">
                    <router-link :to="{name: 'layout.dashboard1'}" class="svg-icon">
                        <svg  class="svg-icon" id="p-dash1" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                        </svg>
                        <span class="ml-4">Dashboards</span>
                    </router-link>
                </li> -->
                <li :class="checkActive(growth) ? 'active' : ''" v-if="showgrowth || showSCM">
                    <a v-b-toggle.growth class="collapsed" >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(240,39,39,1)">
                            <path d="M15.5018 20.0048C14.8432 21.5841 13.5794 22.848 12 23.5066C10.4206 22.848 9.15679 21.5841 8.49816 20.0048H10.7575C11.0838 20.4934 11.5051 20.9171 12 21.248C12.4949 20.9171 12.9162 20.4934 13.2425 20.0048H15.5018ZM18 14.8095L20 17.0777V19.0048H4V17.0777L6 14.8095V9.00478C6 5.52153 8.50442 2.55822 12 1.45999C15.4956 2.55822 18 5.52153 18 9.00478V14.8095ZM17.2692 17.0048L16 15.5653V9.00478C16 6.68694 14.4292 4.57431 12 3.58384C9.57078 4.57431 8 6.68694 8 9.00478V15.5653L6.73076 17.0048H17.2692ZM12 11.0048C10.8954 11.0048 10 10.1093 10 9.00478C10 7.90021 10.8954 7.00478 12 7.00478C13.1046 7.00478 14 7.90021 14 9.00478C14 10.1093 13.1046 11.0048 12 11.0048Z"></path>
                        </svg>
                        <span class="ml-3">로켓그로스
                        </span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="growth" class="iq-submenu" accordion="my-accordion">

                            <li :class="checkActive('growth.growthdb') ? 'active' : ''">
                                <router-link :to="{name: 'growth.growthdb'}">
                                    <i class="las la-minus"></i><span>상품관리
                                    </span>
                                </router-link>
                            </li>
                            <!-- 소싱관리 — 로켓그로스 구독자 전체에게 연다. 부모 그룹(showgrowth || showSCM)을 그대로 따른다.
                                 수강생 데이터(검색량·노출·시장파이)를 쓰는 컬럼을 이 보드에서 뺐으므로
                                 shownomad 로 묶을 이유가 없어졌다 — 여기 남는 건 원가·마진 작업대다. -->
                            <li :class="checkActive('growth.sourcingBoard') ? 'active' : ''">
                                <router-link :to="{name: 'growth.sourcingBoard'}">
                                    <i class="las la-minus"></i><span>소싱관리
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <!-- <li :class="checkActive('growth.growthsales') ? 'active' : ''" v-if="showsales || showlite || showSCM">
                                <router-link :to="{name: 'growth.growthsales'}">
                                    <i class="las la-minus"></i><span>판매현황
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li> -->
                            <!-- <li :class="checkActive('growth.growthscm') ? 'active' : ''">
                                <router-link :to="{name: 'growth.growthscm'}">
                                    <i class="las la-minus"></i><span>공급관리(SCM)
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li> -->
                            <li :class="checkActive('growth.growthscmV0') ? 'active' : ''">
                                <router-link :to="{name: 'growth.growthscmV0'}">
                                    <i class="las la-minus"></i><span>공급관리(SCM)
                                        <!-- <span class="badge bg-success">
                                            new
                                        </span> -->
                                    </span>
                                </router-link>
                            </li>

                            <li :class="checkActive('growth.salesledger') ? 'active' : ''">
                                <router-link :to="{name: 'growth.salesledger'}">
                                    <i class="las la-minus"></i><span>판매장부
                                        <!-- <span class="badge bg-primary">
                                            new
                                        </span> -->
                                    </span>
                                </router-link>
                            </li>
                            <!-- <li :class="checkActive('growth.admanager') ? 'active' : ''">
                                <router-link :to="{name: 'growth.admanager'}">
                                    <i class="las la-minus"></i><span>광고관리
                                    </span>
                                </router-link>
                            </li> -->
                            <!-- <li :class="checkActive('growth.adsstatus') ? 'active' : ''">
                                <router-link :to="{name: 'growth.adsstatus'}">
                                    <i class="las la-minus"></i><span>광고현황
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li> -->
                    </b-collapse>
                </li>
                <!-- 판매자배송 — 로켓그로스·로켓배송과 표·길 따로(D-263) · 공개 전까지 개발자만 -->
                <li :class="checkActive(marketplace) ? 'active' : ''" v-if="showdeveloper">
                    <a v-b-toggle.marketplace class="collapsed">
                        <i class="las la-truck" style="font-size: 24px; color: rgba(0,130,255,1);"></i>
                        <span class="ml-3">판매자배송</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="marketplace" class="iq-submenu" accordion="my-accordion">
                        <li :class="checkActive('marketplace.productManagement') ? 'active' : ''" v-if="showdeveloper">
                            <router-link :to="{name: 'marketplace.productManagement'}">
                                <i class="las la-minus"></i><span>상품관리</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('marketplace.salesLedger') ? 'active' : ''" v-if="showdeveloper">
                            <router-link :to="{name: 'marketplace.salesLedger'}">
                                <i class="las la-minus"></i><span>판매장부</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('marketplace.scm') ? 'active' : ''" v-if="showdeveloper">
                            <router-link :to="{name: 'marketplace.scm'}">
                                <i class="las la-minus"></i><span>공급관리</span>
                            </router-link>
                        </li>
                    </b-collapse>
                </li>
                <li :class="checkActive(product) ? 'active' : ''" v-if="showRocketReg || showdeveloper || showproduct || showpolist || showsales || showlite || showstock">
                    <a v-b-toggle.product class="collapsed">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(0,130,255,1)">
                            <path d="M15.5018 20.0048C14.8432 21.5841 13.5794 22.848 12 23.5066C10.4206 22.848 9.15679 21.5841 8.49816 20.0048H10.7575C11.0838 20.4934 11.5051 20.9171 12 21.248C12.4949 20.9171 12.9162 20.4934 13.2425 20.0048H15.5018ZM18 14.8095L20 17.0777V19.0048H4V17.0777L6 14.8095V9.00478C6 5.52153 8.50442 2.55822 12 1.45999C15.4956 2.55822 18 5.52153 18 9.00478V14.8095ZM17.2692 17.0048L16 15.5653V9.00478C16 6.68694 14.4292 4.57431 12 3.58384C9.57078 4.57431 8 6.68694 8 9.00478V15.5653L6.73076 17.0048H17.2692ZM12 11.0048C10.8954 11.0048 10 10.1093 10 9.00478C10 7.90021 10.8954 7.00478 12 7.00478C13.1046 7.00478 14 7.90021 14 9.00478C14 10.1093 13.1046 11.0048 12 11.0048Z"></path>
                        </svg>
                        <span class="ml-3">로켓배송</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="product" class="iq-submenu" accordion="my-accordion">
                        <li :class="checkActive('AI.AIRocketReg') ? 'active' : ''" v-if="showRocketReg || showdeveloper">
                            <router-link :to="{name: 'AI.AIRocketReg'}">
                                <i class="las la-minus"></i><span>AI상품등록
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('product.rocketProductManagement') ? 'active' : ''" v-if="showproduct">
                            <router-link :to="{name: 'product.rocketProductManagement'}">
                                <i class="las la-minus"></i><span>상품관리(신규)
                                    <span class="badge bg-success">
                                        new
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('product.rocketScm') ? 'active' : ''" v-if="showproduct">
                            <router-link :to="{name: 'product.rocketScm'}">
                                <i class="las la-minus"></i><span>공급관리(신규)
                                    <span class="badge bg-success">
                                        new
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('product.rocketSalesLedger') ? 'active' : ''" v-if="showproduct">
                            <router-link :to="{name: 'product.rocketSalesLedger'}">
                                <i class="las la-minus"></i><span>판매장부(신규)
                                    <span class="badge bg-success">
                                        new
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        
                         <li :class="checkActive('category.listcategory') ? 'active' : ''" v-if="showpolist">
                            <router-link :to="{name: 'category.listcategory'}">
                                <i class="las la-minus"></i><span>발주리스트</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('product.listproduct') ? 'active' : ''" v-if="showproduct">
                            <router-link :to="{name: 'product.listproduct'}">
                                <i class="las la-minus"></i><span>상품관리(기존)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('salesstatus.salesstatus') ? 'active' : ''" v-if="showproduct">
                            <router-link :to="{name: 'salesstatus.salesstatus'}">
                                <i class="las la-minus"></i><span>로켓판매현황(기존)</span>
                            </router-link>
                        </li>
                        <!-- <li :class="checkActive('salesstatus.ai') ? 'active' : ''" v-if="showsales">
                            <router-link :to="{name: 'salesstatus.ai'}">
                                <i class="las la-minus"></i><span>발주수요예측</span>
                            </router-link>
                        </li> -->
                        <li :class="checkActive('product.category') ? 'active' : ''" v-if="showsales || showlite">
                            <router-link :to="{name: 'product.category'}">
                                <i class="las la-minus"></i><span>등록카테고리현황</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('sale.addsale') ? 'active' : ''" v-if="showstock">
                            <router-link :to="{name: 'sale.addsale'}">
                                <i class="las la-minus"></i><span>재고등록</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('sale.listsale') ? 'active' : ''" v-if="showstock">
                            <router-link :to="{name: 'sale.listsale'}">
                                <i class="las la-minus"></i><span>재고리스트(국내)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('sale.totallistsale') ? 'active' : ''" v-if="showstock">
                            <router-link :to="{name: 'sale.totallistsale'}">
                                <i class="las la-minus"></i><span>재고리스트(전체)</span>
                            </router-link>
                        </li>
                    </b-collapse>
                </li>

                <li :class="checkActive(nomad) ? 'active' : ''" v-if="screenGroupVisible('nomad')">
                    <a v-b-toggle.nomad class="collapsed" >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(250,172,4,1)">
                            <path d="M12 11C14.7614 11 17 13.2386 17 16V22H15V16C15 14.4023 13.7511 13.0963 12.1763 13.0051L12 13C10.4023 13 9.09634 14.2489 9.00509 15.8237L9 16V22H7V16C7 13.2386 9.23858 11 12 11ZM5.5 14C5.77885 14 6.05009 14.0326 6.3101 14.0942C6.14202 14.594 6.03873 15.122 6.00896 15.6693L6 16L6.0007 16.0856C5.88757 16.0456 5.76821 16.0187 5.64446 16.0069L5.5 16C4.7203 16 4.07955 16.5949 4.00687 17.3555L4 17.5V22H2V17.5C2 15.567 3.567 14 5.5 14ZM18.5 14C20.433 14 22 15.567 22 17.5V22H20V17.5C20 16.7203 19.4051 16.0796 18.6445 16.0069L18.5 16C18.3248 16 18.1566 16.03 18.0003 16.0852L18 16C18 15.3343 17.8916 14.694 17.6915 14.0956C17.9499 14.0326 18.2211 14 18.5 14ZM5.5 8C6.88071 8 8 9.11929 8 10.5C8 11.8807 6.88071 13 5.5 13C4.11929 13 3 11.8807 3 10.5C3 9.11929 4.11929 8 5.5 8ZM18.5 8C19.8807 8 21 9.11929 21 10.5C21 11.8807 19.8807 13 18.5 13C17.1193 13 16 11.8807 16 10.5C16 9.11929 17.1193 8 18.5 8ZM5.5 10C5.22386 10 5 10.2239 5 10.5C5 10.7761 5.22386 11 5.5 11C5.77614 11 6 10.7761 6 10.5C6 10.2239 5.77614 10 5.5 10ZM18.5 10C18.2239 10 18 10.2239 18 10.5C18 10.7761 18.2239 11 18.5 11C18.7761 11 19 10.7761 19 10.5C19 10.2239 18.7761 10 18.5 10ZM12 2C14.2091 2 16 3.79086 16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2ZM12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"></path>
                        </svg>
                        <span class="ml-3">노마드클럽
                        </span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="nomad" class="iq-submenu" accordion="my-accordion">
                            <li :class="checkActive('nomad.sourcingmasterTS') ? 'active' : ''" v-if="screenVisible('nomad.sourcingmasterTS')">
                                <router-link :to="{name: 'nomad.sourcingmasterTS'}">
                                    <i class="las la-minus"></i><span>TrendSetter소싱
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('nomad.sourcingmasterTF') ? 'active' : ''" v-if="screenVisible('nomad.sourcingmasterTF')">
                                <router-link :to="{name: 'nomad.sourcingmasterTF'}">
                                    <i class="las la-minus"></i><span>TrendFollower소싱
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('nomad.sourcingmasterTF2') ? 'active' : ''" v-if="screenVisible('nomad.sourcingmasterTF2')">
                                <router-link :to="{name: 'nomad.sourcingmasterTF2'}">
                                    <i class="las la-minus"></i><span>TrendFollower소싱2

                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('nomad.saveitemM') ? 'active' : ''" v-if="screenVisible('nomad.saveitemM')">
                                <router-link :to="{name: 'nomad.saveitemM'}">
                                    <i class="las la-minus"></i><span>TS/TF장바구니

                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('nomad.keywordAnalysis') ? 'active' : ''" v-if="screenVisible('nomad.nomadKeywordAnalysis')">
                                <router-link :to="{name: 'nomad.nomadKeywordAnalysis'}">
                                    <i class="las la-minus"></i><span>키워드그래프
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('nomad.nomadCategoryAnalysis') ? 'active' : ''" v-if="screenVisible('nomad.nomadCategoryAnalysis')">
                                <router-link :to="{name: 'nomad.nomadCategoryAnalysis'}">
                                    <i class="las la-minus"></i><span>카테고리최적화
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('nomad.nomadtraffic') ? 'active' : ''" v-if="screenVisible('nomad.nomadtraffic')">
                                <router-link :to="{name: 'nomad.nomadtraffic'}">
                                    <i class="las la-minus"></i><span>트래픽
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('nomad.productTrace') ? 'active' : ''" v-if="screenVisible('nomad.productTrace')">
                                <router-link :to="{name: 'nomad.productTrace'}">
                                    <i class="las la-minus"></i><span>상품추적
                                        <span class="badge bg-primary">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <!-- <li :class="checkActive('nomad.sourcingVerify') ? 'active' : ''" v-if="shownomadv3">
                                <router-link :to="{name: 'nomad.sourcingVerify'}">
                                    <i class="las la-minus"></i><span>AI 소싱진단
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li> -->

                            <!-- <li :class="checkActive('nomad.sourcingmasterv2') ? 'active' : ''" v-if="shownomadv2 || showNomadMenu">
                                <router-link :to="{name: 'nomad.sourcingmasterv2'}">
                                    <i class="las la-minus"></i><span>AI소싱
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('nomad.saveitem') ? 'active' : ''" v-if="shownomadv2 || showNomadMenu">
                                <router-link :to="{name: 'nomad.saveitem'}">
                                    <i class="las la-minus"></i><span>AI장바구니
                                    </span>
                                </router-link>
                            </li> -->

                            <li :class="checkActive('nomad.userlist') ? 'active' : ''" v-if="screenVisible('nomad.userlist')">
                                <router-link :to="{name: 'nomad.userlist'}">
                                    <i class="las la-minus"></i><span>외주 권한관리

                                    </span>
                                </router-link>
                            </li>
                            <!-- <li :class="checkActive('AI.Assistant') ? 'active' : ''" v-if="shownomadv2 || showNomadMenu">
                                <router-link :to="{name: 'AI.Assistant'}">
                                    <i class="las la-minus"></i><span>AI 어시스턴트
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li> -->
                    </b-collapse>
                </li>


                <li :class="checkActive(salesstatus) ? 'active' : ''">
                    <a v-b-toggle.salesstatus class="collapsed">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(12,189,49,1)">
                            <path d="M2 13H8V21H2V13ZM16 8H22V21H16V8ZM9 3H15V21H9V3ZM4 15V19H6V15H4ZM11 5V19H13V5H11ZM18 10V19H20V10H18Z"></path>
                        </svg>
                        <span class="ml-3">판매/분석</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="salesstatus" class="iq-submenu" accordion="my-accordion">
                        <li :class="checkActive('analysis.categorySourcing') ? 'active' : ''" v-if="screenVisible('analysis.categorySourcing')">
                            <router-link :to="{name: 'analysis.categorySourcing'}">
                                <i class="las la-minus"></i><span>카테고리소싱분석
                                </span>
                            </router-link>
                        </li>
                        <!-- 소싱관리 — 2026-09-18 오픈. 담기 3화면(키워드수집기·카테고리소싱분석·키워드소싱분석)과 같은 조건이어야
                             담고도 못 보는 사람이 안 생긴다. 라우터 requiresAuth 와도 같은 3개다 -->
                        <li :class="checkActive('analysis.sourcingBoard') ? 'active' : ''" v-if="screenVisible('analysis.sourcingBoard')">
                            <router-link :to="{name: 'analysis.sourcingBoard'}">
                                <i class="las la-minus"></i><span>소싱관리
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('nomad.keywordCollect') ? 'active' : ''" v-if="screenVisible('nomad.nomadKeywordCollect')">
                            <router-link :to="{name: 'nomad.nomadKeywordCollect'}">
                                <i class="las la-minus"></i><span>키워드수집기
                                </span>
                            </router-link>
                        </li>
                        
                        <li :class="checkActive('analysis.keywordDataCollect') ? 'active' : ''" v-if="screenVisible('analysis.keywordDataCollect')">
                            <router-link :to="{name: 'analysis.keywordDataCollect'}">
                                <i class="las la-minus"></i><span>키워드소싱분석
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('analysis.productCompetitiveAnalysis') ? 'active' : ''" v-if="screenVisible('analysis.productCompetitiveAnalysis')">
                            <router-link :to="{name: 'analysis.productCompetitiveAnalysis'}">
                                <i class="las la-minus"></i><span>상품경쟁력분석
                                </span>
                            </router-link>
                        </li>

                        <li :class="checkActive('analysis.keyword') ? 'active' : ''" v-if="showsales || showlite || showKeywordAnalysis">
                            <router-link :to="{name: 'analysis.keyword'}">
                                <i class="las la-minus"></i><span>키워드분석
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('analysis.ranking') ? 'active' : ''" v-if="showsales || showlite || showCollectRank">
                            <router-link :to="{name: 'analysis.ranking'}">
                                <i class="las la-minus"></i><span>쿠팡 랭킹추적
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('analysis.exposureTracking') ? 'active' : ''" v-if="screenVisible('analysis.exposureTracking')">
                            <router-link :to="{name: 'analysis.exposureTracking'}">
                                <i class="las la-minus"></i><span>노출추적
                                    <span class="badge bg-success">
                                        new
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('analysis.aibuyExplorer') ? 'active' : ''">
                            <router-link :to="{name: 'analysis.aibuyExplorer'}">
                                <i class="las la-minus"></i><span>1688탐색
                                    <span class="badge bg-success">
                                        new
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('analysis.keywordoptimize') ? 'active' : ''" v-if="showsales">
                            <router-link :to="{name: 'analysis.keywordoptimize'}">
                                <i class="las la-minus"></i><span>상품명메이커</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('product.category_min') ? 'active' : ''" v-if="showMin">
                            <router-link :to="{name: 'product.category_min'}">
                                <i class="las la-minus"></i><span>카테고리현황
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('nomad.categoryAnalysis') ? 'active' : ''" v-if="showMin">
                            <router-link :to="{name: 'nomad.categoryAnalysis'}">
                                <i class="las la-minus"></i><span>카테고리심층분석
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('analysis.trackingsales') ? 'active' : ''" v-if="showsales || showlite">
                            <router-link :to="{name: 'analysis.trackingsales'}">
                                <i class="las la-minus"></i><span>경쟁사 판매추적
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('analysis.sourcing') ? 'active' : ''" v-if="showsales">
                            <router-link :to="{name: 'analysis.sourcing'}">
                                <i class="las la-minus"></i><span>상품소싱 (N쇼핑해외)
                                </span>
                            </router-link>
                        </li>

                    </b-collapse>
                </li>



                <li :class="checkActive(Ad) ? 'active' : ''" v-if="screenGroupVisible('ad')">
                    <a v-b-toggle.ad class="collapsed" >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(12,189,49,1)">
                            <path d="M7.55197 13 8.39897 10.8852 9.24398 13H7.55197ZM16 12H17V14H16C15.4477 14 15 13.5523 15 13 15 12.4477 15.4477 12 16 12ZM21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3ZM12.598 16H10.443L10.043 15H6.75297L6.35297 16H4.19897L5.39797 13.002 5.39897 13 7.39897 8H9.39897L12.598 16ZM17 8H19V16H16C14.3431 16 13 14.6569 13 13 13 11.3431 14.3431 10 16 10H17V8Z"></path>
                        </svg>
                        <span class="ml-3">광고관리</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="ad" class="iq-submenu" accordion="my-accordion">
                            <!-- <li :class="checkActive('Ad.adkeyword') ? 'active' : ''">
                                <router-link :to="{name: 'Ad.adkeyword'}">
                                    <i class="las la-minus"></i><span>수동키워드광고
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li> -->
                            <li :class="checkActive('Ad.adSourcing') ? 'active' : ''">
                                <router-link :to="{name: 'Ad.adSourcing'}">
                                    <i class="las la-minus"></i><span>광고관리(상품검증)
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('growth.admanager') ? 'active' : ''" v-if="showAdManager">
                                <router-link :to="{name: 'growth.admanager'}">
                                    <i class="las la-minus"></i><span>광고관리(대시보드)
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <!-- <li :class="checkActive('Ad.adMarketing') ? 'active' : ''">
                                <router-link :to="{name: 'Ad.adMarketing'}">
                                    <i class="las la-minus"></i><span>광고관리(수동)
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li> -->
                    </b-collapse>
                </li>

                <li :class="checkActive(purchases) ? 'active' : ''" v-if="showpurchase || showCoupass">
                    <a v-b-toggle.purchase1 class="collapsed">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(12,189,49,1)">
                            <path d="M8.96456 18C8.72194 19.6961 7.26324 21 5.5 21C3.73676 21 2.27806 19.6961 2.03544 18H1V6C1 5.44772 1.44772 5 2 5H16C16.5523 5 17 5.44772 17 6V8H20L23 12.0557V18H20.9646C20.7219 19.6961 19.2632 21 17.5 21C15.7368 21 14.2781 19.6961 14.0354 18H8.96456ZM15 7H3V15.0505C3.63526 14.4022 4.52066 14 5.5 14C6.8962 14 8.10145 14.8175 8.66318 16H14.3368C14.5045 15.647 14.7296 15.3264 15 15.0505V7ZM17 13H21V12.715L18.9917 10H17V13ZM17.5 19C18.1531 19 18.7087 18.5826 18.9146 18C18.9699 17.8436 19 17.6753 19 17.5C19 16.6716 18.3284 16 17.5 16C16.6716 16 16 16.6716 16 17.5C16 17.6753 16.0301 17.8436 16.0854 18C16.2913 18.5826 16.8469 19 17.5 19ZM7 17.5C7 16.6716 6.32843 16 5.5 16C4.67157 16 4 16.6716 4 17.5C4 17.6753 4.03008 17.8436 4.08535 18C4.29127 18.5826 4.84689 19 5.5 19C6.15311 19 6.70873 18.5826 6.91465 18C6.96992 17.8436 7 17.6753 7 17.5Z"></path>
                        </svg>
                        <span class="ml-3">쿠패스
                            <span v-if="$store.state.sseNotifications.quotation_created > 0 || $store.state.sseNotifications.price_modified > 0 || $store.state.sseNotifications.payment_completed > 0" class="sidebar-noti-dot"></span>
                        </span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="purchase1" class="iq-submenu" accordion="my-accordion" v-if="showpurchase || showCoupass">
                        <li :class="checkActive('nomad.nomadreqpo') ? 'active' : ''" v-if="showCoupass">
                            <router-link :to="{name: 'nomad.nomadreqpo'}">
                                <i class="las la-minus"></i><span>구매요청(그로스)
                                    <span v-if="$store.state.sseNotifications.quotation_created > 0" class="sidebar-noti-dot"></span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('purchase.listreqpurchases') ? 'active' : ''" v-if="showCoupass">
                            <router-link :to="{name: 'purchase.listreqpurchases'}">
                                <i class="las la-minus"></i><span>구매내역(그로스)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('logis.stockmanagement') ? 'active' : ''" v-if="showCoupass && $store.state.settings && $store.state.settings[0] && $store.state.settings[0].coupassSyncEnabled">
                            <router-link :to="{name: 'logis.stockmanagement'}">
                                <i class="las la-minus"></i><span>재고관리
                                    <span v-if="$store.state.sseNotifications.shipment_requested > 0" class="sidebar-noti-dot"></span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('growth.samplePo') ? 'active' : ''" v-if="showCoupass">
                            <router-link :to="{name: 'growth.samplePo'}">
                                <i class="las la-minus"></i><span>샘플검증요청
                                    <span class="badge bg-success">
                                        new
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('purchase.reqpurchase') ? 'active' : ''" v-if="showpurchase">
                            <router-link :to="{name: 'purchase.reqpurchase'}">
                                <i class="las la-minus"></i><span>구매요청(로켓)</span>
                            </router-link>
                        </li>
                        <!-- 쿠패스 창고 정리 전까지 숨김 (오픈 시 주석 해제)
                        <li :class="checkActive('purchase.reqpurchaseTracking') ? 'active' : ''" v-if="showpurchase">
                            <router-link :to="{name: 'purchase.reqpurchaseTracking'}">
                                <i class="las la-minus"></i><span>구매내역관리</span>
                            </router-link>
                        </li>
                        -->
                        <li :class="checkActive('purchase.listreqpurchases') ? 'active' : ''" v-if="showpurchase">
                            <router-link :to="{name: 'purchase.listreqpurchases'}">
                                <i class="las la-minus"></i><span>구매내역(로켓)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('nomad.reqpurchaseV0') ? 'active' : ''" v-if="showpurchase || showCoupass">
                            <router-link :to="{name: 'nomad.reqpurchaseV0'}">
                                <i class="las la-minus"></i><span>통합 구매요청
                                    <span class="badge bg-primary">
                                        통합
                                    </span>
                                </span>
                            </router-link>
                        </li>
                    </b-collapse>
                </li>

                <!-- <li :class="checkActive(purchases) ? 'active' : ''" v-if="showdeveloper">
                    <a v-b-toggle.purchase class="collapsed">
                        <svg class="svg-icon" id="p-dash5" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                            <line x1="1" y1="10" x2="23" y2="10"></line>
                        </svg>
                        <span class="ml-3">구매(기존)</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="purchase" class="iq-submenu" accordion="my-accordion">
                        <li :class="checkActive('purchase.listpurchases') ? 'active' : ''">
                            <router-link :to="{name: 'purchase.listpurchases'}">
                                <i class="las la-minus"></i><span>구매내역</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('purchase.addpurchase') ? 'active' : ''">
                            <router-link :to="{name: 'purchase.addpurchase'}">
                                <i class="las la-minus"></i><span>1688주문서생성</span>
                            </router-link>
                        </li>
                    </b-collapse>
                </li> -->

                <li :class="checkActive(logistics) ? 'active' : ''" v-if="showimport">
                    <a v-b-toggle.logistics class="collapsed">
                        <svg class="svg-icon" id="p-dash14" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>
                        </svg>
                        <span class="ml-3">해외물류</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="logistics" class="iq-submenu" accordion="my-accordion">
                        <li :class="checkActive('logistics.logis') ? 'active' : ''">
                                <router-link :to="{name: 'logistics.logis'}">
                                    <i class="las la-minus"></i><span>물류재고</span>
                                </router-link>
                        </li>
                        <li :class="checkActive('logistics.logisinvoice') ? 'active' : ''">
                                <router-link :to="{name: 'logistics.logisinvoice'}">
                                    <i class="las la-minus"></i><span>출고내역(Invoice)</span>
                                </router-link>
                        </li>
                    </b-collapse>
                </li>


                <!-- <li :class="checkActive(sale) ? 'active' : ''" v-if="showstock">
                    <a v-b-toggle.sale class="collapsed">
                        <svg class="svg-icon" id="p-dash4" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                        </svg>
                        <span class="ml-3">재고/배치</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="sale" class="iq-submenu" accordion="my-accordion">
                            <li :class="checkActive('sale.addsale') ? 'active' : ''">
                                    <router-link :to="{name: 'sale.addsale'}">
                                        <i class="las la-minus"></i><span>재고등록</span>
                                    </router-link>
                            </li>
                            <li :class="checkActive('sale.listsale') ? 'active' : ''">
                                    <router-link :to="{name: 'sale.listsale'}">
                                        <i class="las la-minus"></i><span>재고리스트(국내)</span>
                                    </router-link>
                            </li>
                            <li :class="checkActive('sale.totallistsale') ? 'active' : ''">
                                    <router-link :to="{name: 'sale.totallistsale'}">
                                        <i class="las la-minus"></i><span>재고리스트(전체)</span>
                                    </router-link>
                            </li>

                    </b-collapse>
                </li> -->
                <li :class="checkActive(exp) ? 'active' : ''" v-if="showexport">
                    <a v-b-toggle.exp class="collapsed" >
                        <svg class="svg-icon" id="p-dash19" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                        </svg>
                        <span class="ml-3">출고</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="exp" class="iq-submenu" accordion="my-accordion">
                            <li :class="checkActive('export.addexport') ? 'active' : ''">
                                <router-link :to="{name: 'export.addexport'}">
                                    <i class="las la-minus"></i><span>출고준비</span>
                                </router-link>
                            </li>
                            <li :class="checkActive('export.exportlist') ? 'active' : ''">
                                <router-link :to="{name: 'export.exportlist'}">
                                    <i class="las la-minus"></i><span>출고리스트</span>
                                </router-link>
                            </li>

                    </b-collapse>
                </li>




                <li :class="checkActive(AI) ? 'active' : ''" v-if="showAI">
                    <a v-b-toggle.AI class="collapsed" >
                        <svg class="svg-icon" id="p-dash13" width="24" height="24"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                        </svg>
                        <span class="ml-3">쿠플러스AI
                        </span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="AI" class="iq-submenu" accordion="my-accordion">
                            <li :class="checkActive('AI.KnowledgeBase') ? 'active' : ''" v-if="showdeveloper">
                                <router-link :to="{name: 'AI.KnowledgeBase'}">
                                    <i class="las la-minus"></i><span>지식 베이스 관리
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('AI.Assistant') ? 'active' : ''" v-if="showdeveloper">
                                <router-link :to="{name: 'AI.Assistant'}">
                                    <i class="las la-minus"></i><span>AI 어시스턴트
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('AI.CleanUp') ? 'active' : ''" v-if="showdeveloper">
                                <router-link :to="{name: 'AI.CleanUp'}">
                                    <i class="las la-minus"></i><span>Clean up
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('AI.NanoBanana') ? 'active' : ''" v-if="showAI">
                                <router-link :to="{name: 'AI.NanoBanana'}">
                                    <i class="las la-minus"></i><span>나노바나나
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                    </b-collapse>
                    <b-collapse tag="ul" id="AI" class="iq-submenu" accordion="my-accordion">
                            <li :class="checkActive('AI.AIimage') ? 'active' : ''" v-if="showdeveloper">
                                <router-link :to="{name: 'AI.AIimage'}">
                                    <i class="las la-minus"></i><span>AI이미지에디터
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                    </b-collapse>
                    <b-collapse tag="ul" id="AI" class="iq-submenu" accordion="my-accordion">
                            <li :class="checkActive('AI.AIpage') ? 'active' : ''" v-if="showdeveloper">
                                <router-link :to="{name: 'AI.AIpage'}">
                                    <i class="las la-minus"></i><span>AI상세페이지
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                            <li :class="checkActive('AI.AIpageV2') ? 'active' : ''" v-if="showdeveloper">
                                <router-link :to="{name: 'AI.AIpageV2'}">
                                    <i class="las la-minus"></i><span>AI상세페이지V2
                                        <span class="badge bg-success">
                                            new
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                    </b-collapse>
                </li>

                    <li :class="checkActive('product.category') ? 'active' : ''" v-if="showlite">
                        <router-link :to="{name: 'product.category'}" class="svg-icon">
                            <svg  class="svg-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                            </svg>
                            <span class="ml-4">신규로켓등록현황</span>
                        </router-link>
                    </li>
                    <li :class="checkActive('analysis.trackingsales') ? 'active' : ''" v-if="showlite">
                        <router-link :to="{name: 'analysis.trackingsales'}" class="svg-icon">
                            <svg  class="svg-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                            </svg>
                            <span class="ml-4">경쟁사 판매추적</span>
                        </router-link>
                    </li>
                    <li :class="checkActive('analysis.ranking') ? 'active' : ''" v-if="showlite || showCollectRank">
                        <router-link :to="{name: 'analysis.ranking'}" class="svg-icon">
                            <svg  class="svg-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                            </svg>
                            <span class="ml-4">쿠팡 랭킹추적</span>
                        </router-link>
                    </li>
                    <li :class="checkActive('analysis.keyword') ? 'active' : ''" v-if="showlite || showKeywordAnalysis">
                        <router-link :to="{name: 'analysis.keyword'}" class="svg-icon">
                            <svg  class="svg-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                            </svg>
                            <span class="ml-4">키워드분석</span>
                        </router-link>
                    </li>
                    <li :class="checkActive('analysis.keywordoptimize') ? 'active' : ''" v-if="showlite || makeProductName">
                        <router-link :to="{name: 'analysis.keywordoptimize'}" class="svg-icon">
                            <svg  class="svg-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                            </svg>
                            <span class="ml-4">상품명메이커</span>
                        </router-link>
                   </li>


                <li :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                    <a v-b-toggle.logis class="collapsed" >
                        <svg class="svg-icon" id="p-dash13" width="24" height="24"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                        </svg>
                        <span class="ml-3">COUPLUS WEIHAI</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="logis" class="iq-submenu" accordion="my-accordion">
                        <!-- ── 📦 업무 메뉴 — 이름은 views/backend/Logis/coupassMenu.js 한 곳(페이지 제목·탭 제목도 같이 쓴다) ── -->
                        <!-- 업무 단계별 그룹(구매→입고→재고→출고→설정) + 그룹 색 띠로 비슷한 이름을 구분한다. 通知·用户 는 맨 아래(2026-10-04 YZY) -->
                        <li class="coupass-grp-head coupass-grp--buy" style="pointer-events:none;"><small>采购(구매)</small></li>
                        <li class="coupass-grp-item coupass-grp--buy" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisreqpurchaseV0'}" >
                                <svg class="svg-icon" id="p-dash5" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                                    <line x1="1" y1="10" x2="23" y2="10"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisreqpurchaseV0') }}
                                    <span v-if="$store.state.sseNotifications.price_modified > 0 || $store.state.sseNotifications.payment_completed > 0" class="sidebar-noti-dot"></span>
                                </span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--buy" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logispaidorderlist'}" >
                                <svg class="svg-icon" id="p-dash13po" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logispaidorderlist') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-head coupass-grp--in" style="pointer-events:none;"><small>入库(입고)</small></li>
                        <li class="coupass-grp-item coupass-grp--in" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisinboundregister'}" >
                                <svg class="svg-icon" id="p-dash13ir" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7V5a2 2 0 0 1 2-2h2"></path><path d="M17 3h2a2 2 0 0 1 2 2v2"></path><path d="M21 17v2a2 2 0 0 1-2 2h-2"></path><path d="M7 21H5a2 2 0 0 1-2-2v-2"></path><line x1="7" y1="8" x2="7" y2="16"></line><line x1="11" y1="8" x2="11" y2="16"></line><line x1="14" y1="8" x2="14" y2="16"></line><line x1="17" y1="8" x2="17" y2="16"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisinboundregister') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--in" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisaddimportV0'}" >
                                <svg class="svg-icon" id="p-dash13v0" width="20" height="20"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisaddimportV0') }}</span>
                            </router-link>
                        </li>
                        <!-- 韩文标签资料 — 식검/KC 한글표시사항·KC 인증서류(2026-10-07 YZY). 入库处理 라벨 출력이 읽는다 -->
                        <li class="coupass-grp-item coupass-grp--in" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.productlabels'}" >
                                <svg class="svg-icon" id="p-dash13kl" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.productlabels') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--in" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisinboundlist'}" >
                                <svg class="svg-icon" id="p-dash13il" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisinboundlist') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-head coupass-grp--todo" style="pointer-events:none;"><small>代办</small></li>
                        <!-- 代办列表·待客户确认은 入库 그룹에서 떼어 «代办» 그룹으로(핑크, 2026-10-16 SYL #31) -->
                        <li class="coupass-grp-item coupass-grp--todo" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisimporterrorlist'}" >
                                <svg class="svg-icon" id="p-dash13ie" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisimporterrorlist') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--todo" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisinboundconfirm'}" >
                                <svg class="svg-icon" id="p-dash13ic" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisinboundconfirm') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-head coupass-grp--stock" style="pointer-events:none;"><small>库存(재고)</small></li>
                        <li class="coupass-grp-item coupass-grp--stock" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisstocklist'}" >
                                <svg class="svg-icon" id="p-dash13sl" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisstocklist') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--stock" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisphotolibrary'}" >
                                <svg class="svg-icon" id="p-dash13pl" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisphotolibrary') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--stock" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.boxphotostatus'}" >
                                <svg class="svg-icon" id="p-dash13bp" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.boxphotostatus') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--stock" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.boxphotoscan'}" >
                                <svg class="svg-icon" id="p-dash13bs" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.boxphotoscan') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--stock" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.ownerleader'}" >
                                <svg class="svg-icon" id="p-dash13ol" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.ownerleader') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-head coupass-grp--out" style="pointer-events:none;"><small>出库(출고)</small></li>
                        <li class="coupass-grp-item coupass-grp--out" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisshipoutrequest'}" >
                                <svg class="svg-icon" id="p-dash13so" style="flex-shrink:0" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>
                                </svg>
                                <!-- 셀러 출고요청 알림점 — 货主库存出库 이 독립 메뉴가 되어 여기 단다(2026-10) -->
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisshipoutrequest') }}
                                    <span v-if="$store.state.sseNotifications.shipment_requested > 0" class="sidebar-noti-dot"></span>
                                </span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--out" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.warehousemanagement'}" >
                                <svg class="svg-icon" id="p-dash5" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                                    <line x1="1" y1="10" x2="23" y2="10"></line>
                                </svg>
                                <!-- 待手动匹配(수동 매칭 대기) 남은 행 수 — 별도 메뉴를 이 화면 待出库列表 탭으로 합치면서 숫자도 여기로(2026-10-07 YZY) -->
                                <span class="ml-4">{{ coupassMenuTitle('logis.warehousemanagement') }}
                                    <span v-if="outboundPendingCount > 0" class="badge badge-warning ml-1" title="待手动匹配(수동 매칭 대기)">{{ outboundPendingCount }}</span>
                                </span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--out" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.invoicelicenses'}" >
                                <svg class="svg-icon" id="p-dash13iv" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="8" y1="13" x2="16" y2="13"></line><line x1="8" y1="17" x2="16" y2="17"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.invoicelicenses') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--out" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.customssettlement'}" >
                                <svg class="svg-icon" id="p-dash13cs" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><polyline points="9 15 11 17 15 13"></polyline>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.customssettlement') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--out" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.lclbillsplit'}" >
                                <svg class="svg-icon" id="p-dash13lb" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="11" x2="12" y2="17"></line><polyline points="9 14 12 17 15 14"></polyline>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.lclbillsplit') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-head coupass-grp--sys" style="pointer-events:none;"><small>系统(설정)</small></li>
                        <!-- 쿠패스 대표 전용 — 대표 여부는 서버가 판정(/api/coupass-staff/me) -->
                        <li class="coupass-grp-item coupass-grp--sys" :class="checkActive('logis.staffaccounts') ? 'active' : ''" v-if="showadmin && showCoupassStaffAdmin">
                            <router-link :to="{name: 'logis.staffaccounts'}" >
                                <svg class="svg-icon" id="p-dash5sa" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.staffaccounts') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--sys" :class="checkActive('logis.csassistant') ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.csassistant'}" >
                                <svg class="svg-icon" id="p-dash5cs" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.csassistant') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--sys" :class="checkActive('logis.feedbackboard') ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.feedbackboard'}" >
                                <svg class="svg-icon" id="p-dash5fb" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><polyline points="3 6 4 7 6 5"></polyline>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.feedbackboard') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--sys" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisnotify'}" >
                                <svg class="svg-icon" id="p-dash19" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisnotify') }}</span>
                            </router-link>
                        </li>
                        <li class="coupass-grp-item coupass-grp--sys" :class="checkActive(logis) ? 'active' : ''" v-if="showadmin">
                            <router-link :to="{name: 'logis.logisuserlist'}" >
                                <svg class="svg-icon" id="p-dash5" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                                    <line x1="1" y1="10" x2="23" y2="10"></line>
                                </svg>
                                <span class="ml-4">{{ coupassMenuTitle('logis.logisuserlist') }}</span>
                            </router-link>
                        </li>

                        <!-- ── ⚙️ 레거시 (이전시스템) — 기본 접힘, 머리말 클릭으로 펼침(2026-10-04 YZY) ── -->
                        <li class="coupass-legacy-head" v-if="showadmin">
                            <a href="javascript:void(0)" @click.prevent="toggleLegacy">
                                <small class="text-muted">⚙️ 旧系统(이전시스템)</small>
                                <i class="coupass-legacy-caret" :class="{ open: legacyOpen }"></i>
                            </a>
                        </li>
                        <li :class="checkActive(logis) ? 'active' : ''" v-if="showadmin" v-show="legacyOpen">
                            <router-link :to="{name: 'logis.logisreqpurchase'}" >
                                <svg class="svg-icon" id="p-dash5" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                                    <line x1="1" y1="10" x2="23" y2="10"></line>
                                </svg>
                                <span class="ml-4">商品代购(구매대행)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive(logis) ? 'active' : ''" v-if="showadmin" v-show="legacyOpen">
                            <router-link :to="{name: 'logis.logispurchaselist'}">
                                <svg class="svg-icon" id="p-dash3" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                </svg>
                                <span class="ml-4">订单列表(구매내역)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive(logis) ? 'active' : ''" v-if="showadmin" v-show="legacyOpen">
                            <router-link :to="{name: 'logis.logisTotalList'}">
                                <svg class="svg-icon" id="p-dash3" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                </svg>
                                <span class="ml-4">订单列表(종합리스트)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive(logis) ? 'active' : ''" v-if="showadmin" v-show="legacyOpen">
                            <router-link :to="{name: 'logis.logisimportbox'}" >
                                <svg class="svg-icon" id="p-dash13" width="20" height="20"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                </svg>
                                <span class="ml-4">商品入库(입고)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive(logis) ? 'active' : ''" v-if="showadmin" v-show="legacyOpen">
                            <router-link :to="{name: 'logis.logisaddimport'}" >
                                <svg class="svg-icon" id="p-dash13" width="20" height="20"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                </svg>
                                <span class="ml-4">商品入出库(입출고)</span>
                            </router-link>
                        </li>
                        <li :class="checkActive(logis) ? 'active' : ''" v-if="showadmin" v-show="legacyOpen">
                            <router-link :to="{name: 'logis.logisimportlist'}" >
                                <svg class="svg-icon" id="p-dash19" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                                </svg>
                                <span class="ml-4">出库列表(출고내역)</span>
                            </router-link>
                        </li>

                    </b-collapse>
                </li>

                <!-- 관리자 메뉴 -->
                <li :class="checkActive(admin) ? 'active' : ''" v-if="showdeveloper">
                    <a v-b-toggle.admin class="collapsed">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(255,0,0,1)">
                            <path d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM12 3.311L4.5 7.653V16.347L12 20.689L19.5 16.347V7.653L12 3.311ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"></path>
                        </svg>
                        <span class="ml-3">관리자</span>
                        <svg class="svg-icon iq-arrow-right arrow-active" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>
                        </svg>
                    </a>
                    <b-collapse tag="ul" id="admin" class="iq-submenu" accordion="my-accordion">
                        <li :class="checkActive('admin.api-monitor') ? 'active' : ''">
                            <router-link :to="{name: 'admin.api-monitor'}">
                                <i class="las la-minus"></i><span>API 모니터링
                                    <span class="badge bg-danger">
                                        admin
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('admin.user-auth-manager') ? 'active' : ''">
                            <router-link :to="{name: 'admin.user-auth-manager'}">
                                <i class="las la-minus"></i><span>사용자 권한 관리
                                    <span class="badge bg-danger">
                                        admin
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('admin.gemini-usage') ? 'active' : ''">
                            <router-link :to="{name: 'admin.gemini-usage'}">
                                <i class="las la-minus"></i><span>Gemini 사용량
                                    <span class="badge bg-warning">
                                        AI
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('admin.service-error-logs') ? 'active' : ''">
                            <router-link :to="{name: 'admin.service-error-logs'}">
                                <i class="las la-minus"></i><span>서비스 에러 로그
                                    <span class="badge bg-danger">
                                        LOG
                                    </span>
                                </span>
                            </router-link>
                        </li>
                        <li :class="checkActive('admin.channel-state') ? 'active' : ''">
                            <router-link :to="{name: 'admin.channel-state'}">
                                <i class="las la-minus"></i><span>계정 채널 상태</span>
                            </router-link>
                        </li>
                        <li :class="checkActive('admin.coupons') ? 'active' : ''">
                            <router-link :to="{name: 'admin.coupons'}">
                                <i class="las la-minus"></i><span>쿠폰 발급
                                    <span class="badge bg-danger">
                                        admin
                                    </span>
                                </span>
                            </router-link>
                        </li>
                    </b-collapse>
                </li>
            </ul>
        </nav>
        <!-- <div id="sidebar-bottom" class="position-relative sidebar-bottom">
            <div class="card border-none">
                <div class="card-body p-0">
                    <div class="sidebarbottom-content">
                        <div class="image"><img src="@/assets/images/layouts/side-bkg.png" class="img-fluid" alt="side-bkg"></div>
                        <h6 class="mt-4 px-4 body-title">Get More Feature by Upgrading</h6>
                        <button type="button" class="btn sidebar-bottom-btn mt-4">Go Premium</button>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="p-3"></div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import {core} from '@/config/pluginInit'
import { coupassMenuTitle, isCoupassTabRoute } from '@/views/backend/Logis/coupassMenu'
import { canSeeScreen, canSeeScreenGroup } from '@/utils/screenAuth'   // 수강생 화면 권한 표 — 라우터·서버·확장과 같은 원본
// 메뉴 권한 칸 — store 사용자 정보에서 뽑는다. data() 에서 한 번만 읽으면, 그 순간 로그인 정보가
// 비어 있을 때 새로고침 전까지 메뉴가 대시보드·1688탐색만 남았다. 아래 watch 가 같은 함수로 다시 맞춘다
function sidebarAuthFlags(u) {
  u = u || {}
  const a = u.auth || {}
  return {
    showdashboard : a.showdashboard,
    showgrowth : a.showgrowth ? a.showgrowth : false,
    showCoupass : a.showCoupass ? a.showCoupass : false,
    showproduct : a.showproduct,
    showpolist : a.showpolist,
    showstock : a.showstock,
    showpurchase : a.showpurchase,
    showsales : u.addAccount ? true : a.showsales,
    showimport : a.showimport,
    showexport : a.showexport,
    showdeveloper : a.showdeveloper,
    showadmin : a.showadmin,
    shownomad : a.shownomad,
    shownomadv2 : a.shownomadv2,
    shownomadv3 : a.shownomadv3,
    showTraffic : a.showTraffic,
    showNomadKeyword : a.showNomadKeyword,
    showNomadCategory : a.showNomadCategory,
    showNomadAdKeyword : a.showNomadAdKeyword,
    showSCM : a.showSCM,
    showlite : u.addAccount ? false : a.showlite,
    addAccount : u.addAccount,
    showMin :a.showMin,
    showAd : a.showAd,
    showAdManager : a.showAdManager,
    showAI : a.showAI,
    showKeywordCollect : a.showKeywordCollect,
    showKeywordTraffic : a.showKeywordTraffic,
    showCollectRank : a.showCollectRank,
    showRocketReg : a.showRocketReg,
    showManualKeywordAd : a.showManualKeywordAd,
    showNomadMenu : a.showNomadMenu,
    showNomadAdManage : a.showNomadAdManage,
    showKeywordAnalysis : a.showKeywordAnalysis,
    makeProductName : a.makeProductName
  }
}

export default {
  name:"SidebarStyle",
  data () {
    return{
      nomad:['nomad.sourcingmaster','nomad.sourcingmasterTS','nomad.sourcingmasterTF','nomad.nomadreqpo','nomad.sourcingmasterv2','nomad.saveitem','nomad.saveitemM','nomad.userlist','nomad.nomadKeywordAnalysis','nomad.nomadKeywordCollect','nomad.sourcingmasterTF2','nomad.sourcingVerify','nomad.nomadCategoryAnalysis','nomad.categoryAnalysis','nomad.nomadtraffic','nomad.productTrace'],
      AI:['AI.AIRocketReg','AI.AIpage','AI.AIpageV2','AI.AIimage','AI.CleanUp','AI.Test','AI.Assistant','AI.KnowledgeBase','AI.NanoBanana'],
      Ad:['Ad.adkeyword','Ad.adSourcing','Ad.adMarketing','growth.admanager'],
      admin:['admin.api-monitor','admin.user-auth-manager','admin.gemini-usage','admin.service-error-logs','admin.channel-state','admin.coupons'],
      product:['product.listproduct','product.rocketProductManagement','product.rocketSalesLedger','product.rocketScm','product.addproduct','product.regproduct','product.category'],
      marketplace:['marketplace.productManagement','marketplace.salesLedger','marketplace.scm'],
      coubnam:['product.category_min'],
      growth:['growth.growthsales','growth.growthscm','growth.growthscmV0','growth.salesledger','growth.admanager','growth.salesstatus','growth.adsstatus','growth.bookkeeping','growth.salesbook','growth.sourcingBoard'],
      sale:['sale.listsale','sale.addsale','sale.totallistsale','sale.logis'],
      salesstatus:['salesstatus.salesstatus','analysis.keyword','salesstatus.ai','analysis.trackingsales','analysis.ranking','analysis.exposureTracking','analysis.aibuyExplorer','analysis.sourcing','analysis.keywordoptimize','analysis.keywordDataCollect','analysis.categorySourcing','analysis.sourcingBoard','analysis.productCompetitiveAnalysis','analysis.productLinkRankCompare'],
      categories:[ 'category.listcategory','category.addcategory'],
      purchases:['purchase.listpurchases','purchase.listreqpurchases','purchase.addpurchase','purchase.reqpurchase','purchase.reqpurchaseTracking','coupass.unified-purchase','nomad.reqpurchaseV0','logis.stockmanagement'],
      logistics:['logistics.logis','logistics.logisinvoice'],
      exp:['export.exportlist','export.addexport'],
    //   imp:['import.importlist','import.addimport'],
      logis:['logis.logisreqpurchaseV0','logis.reqpurchaseTracking','logis.warehousemanagement','logis.outboundmanualmatch','logis.invoicerecords','logis.invoicelicenses','logis.customssettlement','logis.lclbillsplit','logis.ownerleader','logis.boxphotoscan','logis.logisaddimportV0','logis.logisinboundlist','logis.logisinboundconfirm','logis.logisimporterrorlist','logis.logisphotolibrary','logis.boxphotostatus','logis.logisstocklist','logis.logisshipoutrequest','logis.logispaidorderlist','logis.logisinboundregister','logis.logisreqchanges','logis.logisTotalList','logis.logisnotify','logis.logisuserlist','logis.staffaccounts','logis.csassistant','logis.feedbackboard','logis.logisreqpurchase','logis.logispurchaselist','logis.logisimportbox','logis.logisaddimport','logis.logisimportlist','logis.stockmanagement','logis.logisexportlist','logis.logisaddexport','logis.logisaddpurchase'],
      ...sidebarAuthFlags(this.$store.state.user),
      showCoupassStaffAdmin : false,   // 쿠패스 대표 여부(서버 판정). 직원 계정 관리 메뉴
      outboundPendingCount : 0,        // 出库列表 메뉴 옆 숫자(待手动匹配 남은 행) — 출고리스트 자동 출고 뒤 남은 행(2026-10-07 YZY)
      // 쿠패스 「旧系统(이전시스템)」 섹션 — 기본 접힘. 펼침 여부는 브라우저에 기억, 그 안 메뉴에 있으면 자동 펼침
      legacyRoutes : ['logis.logisreqpurchase','logis.logispurchaselist','logis.logisTotalList','logis.logisimportbox','logis.logisaddimport','logis.logisimportlist'],
      legacyOpen : false,
    //   uselogis : this.$store.state.user.auth.uselogis,
    }
  },
  created () {
    this.legacyOpen = this.readLegacyOpen() || this.isLegacyRoute()
  },
  mounted () {
    core.SmoothScrollbar()
    core.changesidebar()
    this.$store.commit('NAVTAB_RESTORE')
    this.registerNavTab()
    this.checkCoupassStaffAdmin()
    this.loadOutboundPending()
  },
   destroyed () {
    core.SmoothScrollbar()
    core.changesidebar()
  },
  watch: {
    '$route' () {
      if (this.isLegacyRoute()) this.legacyOpen = true
      this.registerNavTab()
      // 쿠패스 화면을 옮겨 다닐 때만 다시 센다(셀러 화면에서는 부르지 않는다)
      if (this.$route && String(this.$route.name || '').indexOf('logis.') === 0) this.loadOutboundPending()
    },
    // 로그인 정보가 늦게 들어오거나 바뀌면 메뉴 권한도 따라간다
    '$store.state.user.auth': {
      deep: true,
      handler () { this.syncAuthFlags() }
    },
    '$store.state.user.addAccount' () { this.syncAuthFlags() }
  },
  computed : {
        ...mapGetters({
            appName: 'appName',
            logo:'logo'
        })
    },
    methods: {
        syncAuthFlags() {
            const wasAdmin = this.showadmin
            Object.assign(this, sidebarAuthFlags(this.$store.state.user))
            // 관리자 권한이 뒤늦게 들어왔으면 mounted 때 건너뛴 쿠패스 관리자 칸도 채운다
            if (this.showadmin && !wasAdmin) {
                this.checkCoupassStaffAdmin()
                this.loadOutboundPending()
            }
        },
        // 수강생 화면 보임 — 판단은 utils/screenAuth.js 한 곳(라우터 가드·서버 API·확장도 같은 표)
        screenVisible(name) { return canSeeScreen(this.$store.state.user, name) },
        screenGroupVisible(group) { return canSeeScreenGroup(this.$store.state.user, group) },
        // 쿠패스 메뉴 이름 — coupassMenu.js 한 곳(페이지 제목과 같이 쓴다)
        coupassMenuTitle(route) { return coupassMenuTitle(route); },
        // 직원 계정 관리 메뉴는 쿠패스 대표에게만 — 대표 판정은 서버 한 곳(AppConfig coupassStaffAdmin)
        async checkCoupassStaffAdmin() {
            if (!this.showadmin) return;
            try {
                const res = await axios.post('/api/coupass-staff/me', {});
                this.showCoupassStaffAdmin = !!(res.data && res.data.owner);
            } catch (e) {
                console.error('직원 계정 관리 권한 확인 실패:', e);
                this.showCoupassStaffAdmin = false;
            }
        },
        // 待手动匹配 남은 행 수 — 쿠패스 관리자(showadmin)만. 서버 권한이 없으면 0
        async loadOutboundPending() {
            if (!this.showadmin) return;
            try {
                const res = await axios.post('/api/coupassOutboundList/pending', {});
                this.outboundPendingCount = res.data && res.data.요청결과 === '성공' ? (res.data.대기 || 0) : 0;
            } catch (e) {
                console.error('수동 매칭 대기 수 불러오기 실패:', e);
                this.outboundPendingCount = 0;
            }
        },
        isLegacyRoute() {
            return !!(this.$route && this.legacyRoutes.includes(this.$route.name));
        },
        readLegacyOpen() {
            try {
                return localStorage.getItem('coupassLegacyOpen') === '1';
            } catch (e) {
                console.error('이전시스템 메뉴 펼침 상태 읽기 실패:', e);
                return false;
            }
        },
        toggleLegacy() {
            this.legacyOpen = !this.legacyOpen;
            try {
                localStorage.setItem('coupassLegacyOpen', this.legacyOpen ? '1' : '0');
            } catch (e) {
                console.error('이전시스템 메뉴 펼침 상태 저장 실패:', e);
            }
        },
        // 헤더 탭 라벨은 사이드바 메뉴명을 그대로 쓴다 (이름을 두 군데 관리하지 않기 위해)
        resolveMenuLabel() {
            const el = this.$el && this.$el.querySelector('li.active > a span');
            if (!el) return '';
            const clone = el.cloneNode(true);
            // 'new' 뱃지, 알림 점은 라벨에서 제외
            clone.querySelectorAll('.badge, .sidebar-noti-dot').forEach(n => n.remove());
            return clone.textContent.replace(/\s+/g, ' ').trim();
        },
        registerNavTab() {
            // active 클래스가 반영된 뒤에 읽어야 한다
            this.$nextTick(() => {
                const route = this.$route;
                if (!route || !route.name) return;
                // 쿠패스 메뉴는 본문 위 쿠패스 탭 바(CoupassTabsView)가 탭을 맡는다 — 헤더 탭을 또 만들면 탭 바 위에 따로 뜬다
                if (isCoupassTabRoute(route.name)) return;
                // 탭은 '사이드바 메뉴'를 나타낸다. 사이드바에 없는 화면(대시보드, 상세페이지 등)은
                // 탭을 만들지 않는다 — 라우트명을 폴백으로 쓰면 'Dashboard1' 같은 내부 이름이 노출된다.
                const label = this.resolveMenuLabel();
                if (!label) return;
                this.$store.commit('NAVTAB_OPEN', {
                    name: route.name,
                    path: route.fullPath,
                    label
                });
            });
        },
        checkActive(route) {
            //import, export logistics업무 관련 내용 추가

            if (this.$route.name == route) {
                return true;
            }
        }
}

}
</script>
<style scoped>
.sidebar-noti-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #dc3545;
  border-radius: 50%;
  margin-left: 4px;
  vertical-align: middle;
}
/* COUPLUS WEIHAI(쿠패스) 업무 그룹 — 비슷한 이름(入库处理/入库列表/出库列表…)을 그룹 색으로 가른다(2026-10-04 YZY) */
.coupass-grp--buy   { --cp-grp: #3b82f6; }
.coupass-grp--in    { --cp-grp: #10b981; }
.coupass-grp--todo  { --cp-grp: #ec4899; }
.coupass-grp--stock { --cp-grp: #8b5cf6; }
.coupass-grp--out   { --cp-grp: #f59e0b; }
.coupass-grp--sys   { --cp-grp: #94a3b8; }
.coupass-grp-head {
  padding: 10px 12px 2px 18px;
  list-style: none;
}
.coupass-grp-head small {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .5px;
  color: var(--cp-grp);
}
.coupass-grp-head small::before {
  content: "";
  width: 4px;
  height: 12px;
  border-radius: 2px;
  margin-right: 6px;
  background: var(--cp-grp);
}
.coupass-grp-item > a {
  border-left: 3px solid var(--cp-grp);
  padding-left: 28px !important;
}
/* 긴 이름이 아이콘을 찌그러뜨려 글자 시작점이 들쭉날쭉하던 것 — 아이콘 크기 고정, 간격 축소 */
.coupass-grp-item > a .svg-icon {
  color: var(--cp-grp);
  flex-shrink: 0;
}
.coupass-grp-item > a .ml-4 {
  margin-left: 12px !important;
}
.coupass-legacy-head > a {
  padding: 12px 12px 4px 18px !important;
  cursor: pointer;
}
.coupass-legacy-caret {
  display: inline-block;
  margin-left: 6px;
  border-left: 5px solid #94a3b8;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  transition: transform .15s;
}
.coupass-legacy-caret.open {
  transform: rotate(90deg);
}
</style>
